import React, { useEffect, useRef } from 'react';
import { experienceData } from '../utils/constants';
import { BriefcaseIcon, MapPinIcon, CalendarIcon, ExternalLinkIcon } from 'lucide-react';
const Experience = ({
  language = 'en'
}) => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const translations = {
    en: {
      professional: 'Professional',
      experience: 'Experience',
      visit: 'Visit'
    },
    vi: {
      professional: 'Kinh Nghiệm',
      experience: 'Chuyên Môn',
      visit: 'Truy cập'
    }
  };
  const t = translations[language];
  return <section id="experience" ref={sectionRef} className="w-full py-24 bg-secondary" data-id="element-167">
      <div className="container mx-auto px-4" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16 fade-in" data-id="element-169">
          {t.professional} <span className="gradient-text" data-id="element-170">{t.experience}</span>
        </h2>
        <div className="relative" data-id="element-171">
          {/* Timeline line - hidden on mobile, visible on md and up */}
          <div className="absolute hidden md:block left-1/2 transform -translate-x-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-accent-cyan to-accent-violet" data-id="element-172"></div>
          {/* Timeline items */}
          <div className="space-y-12" data-id="element-173">
            {experienceData.map((experience, index) => <div key={index} className={`relative flex flex-col md:flex-row ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 fade-in`} style={{
            transitionDelay: `${index * 100}ms`
          }} data-id="element-174">
                {/* Timeline dot - hidden on mobile, visible on md and up */}
                <div className="absolute hidden md:block left-1/2 transform -translate-x-1/2 w-5 h-5 rounded-full bg-accent-cyan" data-id="element-175"></div>
                {/* Content */}
                <div className={`w-full md:w-1/2 ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`} data-id="element-176">
                  <div className="bg-background rounded-2xl p-6 card-glow" data-id="element-177">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-4" data-id="element-178">
                      <div className="w-12 h-12 company-logo-container flex items-center justify-center overflow-hidden" data-id="element-179">
                        <img src={experience.logo} alt={experience.company} className="max-w-full max-h-full object-contain" data-id="element-180" />
                      </div>
                      <div data-id="element-181">
                        <h3 className="text-xl font-display font-bold" data-id="element-182">
                          {language === 'en' ? experience.role : experience.roleVi}
                        </h3>
                        <p className="text-accent-cyan" data-id="element-183">{experience.company}</p>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-4 mb-4 text-sm text-muted" data-id="element-184">
                      <div className="flex items-center gap-1" data-id="element-185">
                        <MapPinIcon size={16} className="text-accent-violet" data-id="element-186" />
                        {language === 'en' ? experience.location : experience.locationVi}
                      </div>
                      <div className="flex items-center gap-1" data-id="element-187">
                        <CalendarIcon size={16} className="text-accent-amber" data-id="element-188" />
                        {language === 'en' ? experience.dates : experience.datesVi}
                      </div>
                    </div>
                    <ul className="space-y-2" data-id="element-189">
                      {(language === 'en' ? experience.description : experience.descriptionVi).map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-190">
                          <span className="text-accent-cyan mt-1" data-id="element-191">•</span>
                          <span data-id="element-192">{item}</span>
                        </li>)}
                    </ul>
                    {experience.website && <div className="mt-4 pt-3 border-t border-accent-cyan/20" data-id="element-193">
                        <a href={experience.website} target="_blank" rel="noopener noreferrer" className="website-link text-accent-cyan hover:text-accent-violet" data-id="element-194">
                          <ExternalLinkIcon size={16} data-id="element-195" />
                          <span data-id="element-196">
                            {t.visit} {experience.company}
                          </span>
                        </a>
                      </div>}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default Experience;